/**
 * Error403Ctrl controller
 * Page 403 controller
 */

/**
 * Error403Ctrl controller
 *
 * @class Error403Ctrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:Error404Ctrl
 */
/* @ngInject */
export default function Error403suCtrl (authSvc) {
  var vm = this
  /**
   * Do logout
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   */
  vm.logout = function () {
    authSvc.doLogout()
  }
}
